module.exports = __webpack_public_path__ + "img/ios-cloud-download.d6eb3071.svg";